import React from "react";
import { useTranslation } from "react-i18next";
import { Route, RouteComponentProps, Switch } from "react-router-dom";
import { MessageEventContext, MessageEventService } from "go-component/components/MessageEvent/services/context";
import { api } from "../../../../../../../../services/Security/api";
import UserLogsMessageEventsIndexPage from "./pages/Index";
import UserLogsMessageEventsPreviewPage from "./pages/Preview";

const UserLogsMessageEventsPage = (props: RouteComponentProps) => {
	const { t } = useTranslation();
	const typesTranslationPrefix = "enums.message_events.type";

	const resources = [
		{
			id: "ORGANIZATION",
			title: t("enums.message_events.resource_type.ORGANIZATION"),
			link: `/admin/organizations`,
		},
		{
			id: "LOAN",
			title: t("enums.message_events.resource_type.LOAN"),
			link: `/admin/loans`,
		},
		{
			id: "PARTNER_SUMMARY",
			title: t("enums.message_events.resource_type.PARTNER_SUMMARY"),
			link: `/admin/payoff`,
		},
		{
			id: "USER",
			title: t("enums.message_events.resource_type.USER"),
		},
		{
			id: "PARTNER",
			title: t("enums.message_events.resource_type.PARTNER"),
			link: `/partnership`,
		},
		{
			id: "TERMINAL",
			title: t("enums.message_events.resource_type.TERMINAL"),
			link: `/admin/terminals`,
		},
		{
			id: "PAYMENT_SOURCE",
			title: t("enums.message_events.resource_type.PAYMENT_SOURCE"),
		},
		{
			id: "PAYMENT",
			title: t("enums.message_events.resource_type.PAYMENT"),
		},
		{
			id: "SEGMENT",
			title: t("enums.message_events.resource_type.SEGMENT"),
		},
		{
			id: "TAG",
			title: t("enums.message_events.resource_type.TAG"),
		},
		{
			id: "CUSTOM_FIELD",
			title: t("enums.message_events.resource_type.CUSTOM_FIELD"),
		},
		{
			id: "WEBHOOK",
			title: t("enums.message_events.resource_type.WEBHOOK"),
		},
		{
			id: "IMAGE",
			title: t("enums.message_events.resource_type.IMAGE"),
		},
		{
			id: "CRASH_REPORT",
			title: t("enums.message_events.resource_type.CRASH_REPORT"),
			link: `/admin/crash_reports`,
		},
	];

	return (
		<MessageEventContext.Provider
			value={
				new MessageEventService(
					{
						all: api.getMessageEvents,
						get: api.getMessageEvent,
						getTypeOptions: api.getMessageEventTypes,
					},
					resources,
					typesTranslationPrefix,
					t
				)
			}
		>
			<Switch>
				<Route exact path={props.match.url} component={UserLogsMessageEventsIndexPage} />
				<Route path={`${props.match.url}/:log_id`} component={UserLogsMessageEventsPreviewPage} />
			</Switch>
		</MessageEventContext.Provider>
	);
};

export default UserLogsMessageEventsPage;

// t("enums.message_events.type.USER_REGISTER");
// t("enums.message_events.type.USER_LOGOUT");
// t("enums.message_events.type.USER_UPDATED");
// t("enums.message_events.type.USER_DELETED");
// t("enums.message_events.type.USER_PASSWORD_REMINDER_MAIL_SENT");
// t("enums.message_events.type.USER_VERIFY_EMAIL_MAIL_SENT");
// t("enums.message_events.type.USER_TERMS_ACCEPTED");
// t("enums.message_events.type.INVITATION_ACCEPTED");
// t("enums.message_events.type.INVITATION_REJECTED");
// t("enums.message_events.type.INVITATION_DELETED");
// t("enums.message_events.type.INVITATION_RESENT");
// t("enums.message_events.type.INVITATION_UPDATED");
// t("enums.message_events.type.INVITATION_CREATED");
// t("enums.message_events.type.INVITATION_MAIL_SENT");
// t("enums.message_events.type.INVITATION_NEW_USER_MAIL_SENT");
// t("enums.message_events.type.INVOICE_MAIL_SENT");
// t("enums.message_events.type.IMAGE_CREATED");
// t("enums.message_events.type.IMAGE_DELETED");
// t("enums.message_events.type.LOAN_ACCEPTED");
// t("enums.message_events.type.LOAN_MERGED");
// t("enums.message_events.type.LOAN_CREATED");
// t("enums.message_events.type.LOAN_OPEN_CANCELLED");
// t("enums.message_events.type.LOAN_SIGNED");
// t("enums.message_events.type.LOAN_CANCEL_SIGN");
// t("enums.message_events.type.LOAN_CLIENT_ACCEPTED");
// t("enums.message_events.type.LOAN_UPDATED");
// t("enums.message_events.type.LOAN_OPENED");
// t("enums.message_events.type.LOAN_CLOSED");
// t("enums.message_events.type.LOAN_CANCELED");
// t("enums.message_events.type.LOAN_ATTACHMENT_DOWNLOADED");
// t("enums.message_events.type.LOAN_MAIL_SENT");
// t("enums.message_events.type.LOAN_ACCEPTANCE_MAIL_SENT");
// t("enums.message_events.type.ORGANIZATION_CREATED");
// t("enums.message_events.type.ORGANIZATION_DELETED");
// t("enums.message_events.type.ORGANIZATION_BLOCKED");
// t("enums.message_events.type.ORGANIZATION_UNBLOCKED");
// t("enums.message_events.type.ORGANIZATION_UPDATED");
// t("enums.message_events.type.ORGANIZATION_RULES_ACCEPTED");
// t("enums.message_events.type.ORGANIZATION_REMOVED");
// t("enums.message_events.type.ORGANIZATION_INFO_UPDATED");
// t("enums.message_events.type.ORGANIZATION_APPLICATION_CREATED");
// t("enums.message_events.type.ORGANIZATION_APPLICATION_UPDATED");
// t("enums.message_events.type.ORGANIZATION_APPLICATION_FROZEN");
// t("enums.message_events.type.ORGANIZATION_APPLICATION_DELETED");
// t("enums.message_events.type.PARTNER_CREATED");
// t("enums.message_events.type.PARTNER_INVITATION_MAIL_SENT");
// t("enums.message_events.type.PARTNER_USER_ADDED");
// t("enums.message_events.type.PARTNER_USER_DELETED");
// t("enums.message_events.type.PARTNER_ORGANIZATION_ADDED");
// t("enums.message_events.type.PARTNER_ORGANIZATION_DELETED");
// t("enums.message_events.type.PARTNER_UPDATED");
// t("enums.message_events.type.PARTNER_ENABLED");
// t("enums.message_events.type.PARTNER_DISABLED");
// t("enums.message_events.type.PARTNER_RESTORED");
// t("enums.message_events.type.PARTNER_ATTACHMENT_CREATED");
// t("enums.message_events.type.PARTNER_ATTACHMENT_CLOSED");
// t("enums.message_events.type.PARTNER_ATTACHMENT_CLOSE_CANCELED");
// t("enums.message_events.type.PARTNER_ATTACHMENT_DELETED");
// t("enums.message_events.type.PARTNER_SUMMARY_CLOSED");
// t("enums.message_events.type.PARTNER_SUMMARY_PAID");
// t("enums.message_events.type.PARTNER_SUMMARY_PAYMENT_CANCELLED");
// t("enums.message_events.type.PARTNER_SUMMARY_MAIL_SENT");
// t("enums.message_events.type.PAYMENT_CREATED");
// t("enums.message_events.type.PAYMENT_IN_PROGRESS");
// t("enums.message_events.type.PAYMENT_PAID");
// t("enums.message_events.type.PAYMENT_ERROR");
// t("enums.message_events.type.PAYMENT_SOURCE_CREATED");
// t("enums.message_events.type.PAYMENT_SOURCE_DISABLED");
// t("enums.message_events.type.SUBSCRIPTION_CREATED");
// t("enums.message_events.type.PERMANENTLY_ORGANIZATION_DELETED");
// t("enums.message_events.type.PROFORMA_MAIL_SENT");
// t("enums.message_events.type.SEGMENT_CREATED");
// t("enums.message_events.type.SEGMENT_UPDATED");
// t("enums.message_events.type.SEGMENT_DELETED");
// t("enums.message_events.type.SEGMENT_DELETED_PERMANENTLY");
// t("enums.message_events.type.SEGMENT_RESTORED");
// t("enums.message_events.type.SUBSCRIPTION_APPLICATION_CREATED");
// t("enums.message_events.type.SUBSCRIPTION_APPLICATION_PAUSED");
// t("enums.message_events.type.SUBSCRIPTION_APPLICATION_RESUMED");
// t("enums.message_events.type.SUBSCRIPTION_APPLICATION_CANCELED");
// t("enums.message_events.type.SUBSCRIPTION_APPLICATION_UPDATED");
// t("enums.message_events.type.TERMINAL_CREATED");
// t("enums.message_events.type.TERMINAL_UPDATED");
// t("enums.message_events.type.USER_PASSWORD_CHANGED");
// t("enums.message_events.type.USER_RESET_PASSWORD_LINK_SENT");
// t("enums.message_events.type.WEBHOOK_CREATED");
// t("enums.message_events.type.WEBHOOK_UPDATED");
// t("enums.message_events.type.WEBHOOK_DELETED");
// t("enums.message_events.type.WEBHOOK_RESTORED");
// t("enums.message_events.type.CUSTOM_FIELD_CREATED");
// t("enums.message_events.type.CUSTOM_FIELD_UPDATED");
// t("enums.message_events.type.CUSTOM_FIELD_RESTORED");
// t("enums.message_events.type.CUSTOM_FIELD_DELETED");
// t("enums.message_events.type.CUSTOM_FIELD_DELETED_PERMANENTLY");
// t("enums.message_events.type.TAG_CREATED");
// t("enums.message_events.type.TAG_UPDATED");
// t("enums.message_events.type.TAG_DELETED");
// t("enums.message_events.type.CRASH_REPORT_ACCEPTED");
// t("enums.message_events.type.CRASH_REPORT_CLOSED");
// t("enums.message_events.type.CRASH_REPORT_IN_PROGRESS");
// t("enums.message_events.type.CRASH_REPORT_RESTORED");
